import { defineStore } from 'pinia'

export const useUebungActivitasCreateStore = defineStore('uebungActivitasCreate', {
  state: () => ({
    latin_lemma_collection: [],
    uebung: {
      title: "",
      content_data: []
    }
  }),
  
  getters: {
    getLatinLemmaCollection: (state) => state.latin_lemma_collection,
    getUebung: (state) => state.uebung
  },
  
  actions: {
    setLatinLemmaCollection(collection) {
      this.latin_lemma_collection = collection
    },
    
    setUebung(uebung) {
      this.uebung = uebung
    },
    
    updateContentData(contentData) {
      this.uebung.content_data = contentData
    }
  }
})
